import { IIssueTrackingComment, IssueTrackingStatusType, ITrackingIssuePointItem } from "app/shared/issue-tracking.service";
import { RAGType } from "../interfaces/annotation-and-rags";
import { Asset } from "./asset";
import { Org } from "./org";
import { User } from "./user";
import { Site } from "./site";
import { IDatesFromTo } from "app/interfaces/dates-from-to";

export class Issue {
	id?: number;
	title: string;
	description: string;
	status: IssueTrackingStatusType = 'open';
	substatus_id: number;
	subStatusTitle: string;
	rag: RAGType = 'green';
	taskProgress?: IssueTaskProgress;
	createdAt?: Date;
	createdBy?: number;
	createdByName?: string;

	assignee?: number;
	assigneeName?: string;

	org_id?: number;
	orgTitle?: string;
	orgShortTitle?: string;
	proposedAction?: string;
	completedAt?: Date;
	completedBy?: number;
	completedByName: string;
	completedNotes?: string;
	visibility: IssueVisibility = 'public';
	documentKey?: string;
	issueType: IssueType;
	entities: IIssueEntity[] = [];
	comments: IIssueTrackingComment[] = [];

	// The org that has visaibility
	org: Org;

	/* categorisation of attached entities for easy retrieval */
	assets?: Asset[] = [];
	//orgs:Org[] = [];
	hasAssets = false;
	hasOrgs = false;

	// Linked orgs related
	orgs: Org[] = [];
	users: User[] = [];
	hasUsers = false;
	buildingReview: IIssueBuildingReview;
	attachments: IIssueAttachment[] = [];

	sites: Site[];
	points: ITrackingIssuePointItem[];

	range: IDatesFromTo;
	resolvedAt: Date;

	constructor(init?: Partial<Issue>) {
		console.log(init);

		if (init.createdAt && typeof init.createdAt === 'string') {
			init.createdAt = new Date(init.createdAt);
		}
		if (init.completedAt && typeof init.completedAt === 'string') {
			init.completedAt = new Date(init.completedAt);
		}
		if (init.resolvedAt && typeof init.resolvedAt === 'string') {
			init.resolvedAt = new Date(init.resolvedAt);
		}

		Object.assign(this, init);

		this.sites = [];

		this.checkEntities();

		if (init.sites) {
			this.sites = init.sites.map(s => new Site(s));
		}
		if (init.assets) {
			this.assets = init.assets.map(a => new Asset(a));
		}
	}

	checkEntities() {
		this.assets = this.entities.filter(e => e.field === 'asset_id').map(a => new Asset({ id: a.value, title: a.title }));
		this.hasAssets = this.entities.filter(e => e.field === 'asset_id').length > 0;
		this.orgs = this.entities.filter(e => e.field === 'org_id').map(o => new Org({ id: o.value, title: o.title }));
		this.hasOrgs = this.orgs.length > 0;
		this.users = this.entities.filter(e => e.field === 'user_id').map(u => new User({ id: u.value, name: u.title }));
		this.hasUsers = this.users.length > 0;

		this.org = new Org({ id: this.org_id, title: this.orgTitle, shortTitle: this.orgShortTitle });
	}

	addEntity(entity: IIssueEntity) {
		this.entities.push(entity);
		this.checkEntities();
	}
}

export interface IIssueBuildingReview {
	id: number;
	building_id: number;
	reviewDate: string;
	createdAt: string;
	createdBy: number;
	state: string;
	document_id: number;
	noOfMonths: number;
	rag: string;
	uuid: string;
	documentKey: string;
	documentTitle: string;
}

export type IssueType = 'issue' | 'task';

export type IssueTaskProgress =
	| 'Analysis'
	| 'Development'
	| 'Testing'
	| 'Review'
	| 'Documentation'
	| 'Waiting feedback'
	| 'Implementing'
	| 'Monitoring'
	| 'Training'
	| 'Configuration'
	| 'Maintenance'
	| 'Not Started';

export type IssueVisibility = 'public' | 'private';

export interface IIssueEntityTable {
	id: number;
	org_id: number;
	site_id: number;
	gateway_id: number;
	asset_id: number;
	user_id: number;
	building_review_id: number;
}

export interface IIssueEntity {
	id?: number;
	field: string;
	value: number | string;
	title?: string;
	isDefault?: boolean;
}

export interface IIssueAttachment {
	bucket: string;
	colour: string | null;
	contentType: string;
	createdAt: Date;
	createdBy: number;
	createdByName: string;
	description: string;
	ext: string;
	filename: string;
	hasPrivacyConcerns: string;
	id: number;
	isDeleted: string;
	isPublic: string;
	key: string;
	notes?: string;
	notesAt?: string;
	notesColour?: string;
	table: string;
	table_id: string;
	title: string;
	updatedAt: string;
}
